import React , {Component} from 'react';
import { Row, Col } from 'antd';

import logo_full from "../../asset/img/logo-mp.png"
import "../../asset/style/morpheus.css"
import "../../asset/style/landing.css"

export class NavBar extends Component {

    render(){
        return(
            <Row className="navbar-parent full-widther">
                <Col span={4}>
                <img className="navbar-logo" src={logo_full} />
                </Col>
            </Row>
        )
    }
  }